import(/* webpackMode: "eager", webpackExports: ["ProviderInformation"] */ "/var/lib/circleci-runner/workdir/modern/applications/widget-next/src/app/components/Header/components/ProviderInformation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyUserMenu"] */ "/var/lib/circleci-runner/workdir/modern/applications/widget-next/src/app/components/Header/components/UserMenu/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/var/lib/circleci-runner/workdir/modern/applications/widget-next/src/app/lib/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/circleci-runner/workdir/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/var/lib/circleci-runner/workdir/node_modules/next/dist/client/script.js");
